import styled from 'styled-components';
import theme from '../../theme';
import Menu from './Menu'; // Keep Menu import if used in styles

export const ContentContainer = styled.div`
  padding: 0rem 1rem 2rem calc(100px + 6rem);
  width: 100%;
  box-sizing: border-box;
  margin-left: 0;
  transition: padding-left 0.3s ease; // Match Analytics transition
  font-family: 'Fustat', ${theme.fonts.main}; // Match Analytics font

  ${Menu}:hover + & { // Match Analytics hover effect
    padding-left: calc(180px + 6rem);
  }
`;

export const ProfileCard = styled.div`
  background: #FEFFFE; // Match Analytics background
  border: 1px solid #E6E6E6; // Match Analytics border color (assuming #E6E6E6)
  border-radius: 20px; // Match Analytics border-radius
  padding: 1.5rem; // Match Analytics padding
  max-width: 600px;
  margin: 2rem auto;
`;

export const Title = styled.h1`
  color: #29435B; // Match Analytics GraphTitle color
  font-family: 'Fustat', ${theme.fonts.main}; // Explicitly match font
  font-size: 23px; // Match Analytics GraphTitle size
  font-style: normal;
  font-weight: 700; // Match Analytics GraphTitle weight
  line-height: normal;
  margin: 0 0 1.5rem 0; // Adjust margin (removed border)
  /* Removed border-bottom and padding-bottom */
`;

export const InfoItem = styled.div`
  margin-bottom: ${theme.spacing.medium};
  font-size: 15px; // Match Analytics font size (e.g., SummarySubtitle)
  color: #29435B; // Match Analytics text color
  font-family: 'Fustat', ${theme.fonts.main};

  strong {
    color: #29435B; // Match primary text color or use theme.colors.noir_clair if preferred
    font-weight: 600; // Make label slightly bolder
    margin-right: ${theme.spacing.small};
  }
`;

export const UaiList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-top: ${theme.spacing.xsmall};
`;

export const UaiItem = styled.li`
  background-color: ${theme.colors.bleu};
  color: ${theme.colors.bleu_tres_fonce};
  padding: ${theme.spacing.xsmall} ${theme.spacing.small};
  border-radius: 5px;
  margin-bottom: ${theme.spacing.xsmall};
  display: inline-block; // Show items side-by-side if space allows
  margin-right: ${theme.spacing.xsmall};
  font-size: ${theme.fontSizes.small};
`;

export const LogoutButton = styled.button`
  background-color: ${theme.colors.bleu_fonce};
  color: ${theme.colors.white};
  border: none;
  border-radius: 8px;
  padding: ${theme.spacing.small} ${theme.spacing.large};
  font-size: ${theme.fontSizes.medium};
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: ${theme.spacing.medium};

  &:hover {
    background-color: ${theme.colors.bleu_tres_fonce};
  }
`;

export const LoadingText = styled.p`
  color: ${theme.colors.gris};
  font-style: italic;
`;

// --- Logout Confirmation Modal Styles ---
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001; // Ensure it's above the menu
`;

export const ModalBox = styled.div`
  background-color: ${theme.colors.white};
  padding: ${theme.spacing.xlarge};
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
  text-align: center;
`;

export const ModalMessage = styled.p`
  font-size: ${theme.fontSizes.medium};
  color: ${theme.colors.noir_clair};
  margin-bottom: ${theme.spacing.large};
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing.medium};
`;

export const ModalButton = styled.button`
  border: none;
  border-radius: 8px;
  padding: ${theme.spacing.small} ${theme.spacing.large};
  font-size: ${theme.fontSizes.medium};
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;

  &:active {
    transform: scale(0.98);
  }
`;

export const ConfirmButton = styled(ModalButton)`
  background-color: ${theme.colors.bleu_fonce};
  color: ${theme.colors.white};

  &:hover {
    background-color: ${theme.colors.bleu_tres_fonce};
  }
`;

export const CancelButton = styled(ModalButton)`
  background-color: transparent;
  color: ${theme.colors.bleu_fonce};
  border: 1px solid ${theme.colors.gris_moyen};

  &:hover {
    background-color: ${theme.colors.gris_clair_clair};
  }
`;
// --- End Modal Styles --- 

export const ShowMoreButton = styled.button`
  background-color: ${theme.colors.white};
  color: ${theme.colors.bleu_fonce};
  border: 1px solid ${theme.colors.bleu_fonce};
  border-radius: 20px;
  padding: 10px 20px;
  font-family: 'Fustat', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${theme.colors.bleu_fonce};
    color: white;
  }
`; 